{
  "form_label_secret_code": {
    "defaultMessage": "Secret code",
    "description": "Label for secret code input field"
  },
  "form_label_email": {
    "defaultMessage": "Email",
    "description": "Label for email address input field"
  },
  "form_label_email_address": {
    "defaultMessage": "Email Address",
    "description": "Label for email address input field"
  },
  "form_label_password": {
    "defaultMessage": "Password",
    "description": "Label for password input field"
  },
  "form_label_room_number": {
    "defaultMessage": "Room Number",
    "description": "Label for room number input field"
  },
  "form_label_last_name": {
    "defaultMessage": "Last Name",
    "description": "Label for last name input field"
  },
  "form_label_pin": {
    "defaultMessage": "Pin",
    "description": "Label for PIN input field"
  },
  "form_label_select_all": {
    "defaultMessage": "Select All",
    "description": "Label for checkbox to select all images"
  },
  "form_label_price": {
    "defaultMessage": "Price (in {currency})",
    "description": "Label for price input field"
  },
  "form_label_unlock_all": {
    "defaultMessage": "Unlock all images",
    "description": "Label for checkbox that unlocks all images"
  },
  "form_label_credit_or_debit_card": {
    "defaultMessage": "Credit or debit card",
    "description": "Label for card input field"
  },
  "form_label_customers_name": {
    "defaultMessage": "Customer's Name",
    "description": "Label for customer's name input field"
  }
}